<template>
<div class="wh100 demo-block" >
  <el-descriptions :column="2" border size="small">
    <el-descriptions-item
        v-for="(item,index) in columnList"
        :label="item.labelName"
        :label-style="{'text-align': 'right','color':'black'}"
        label-class-name="my-label"
        content-class-name="my-content">
      {{buildingData[item.columnName]?buildingData[item.columnName]:'-'}}
    </el-descriptions-item>
    <el-descriptions-item   label="位置："  :label-style="{'text-align': 'right','color':'black','height':'240px'}" label-class-name="my-label" content-class-name="my-content">
       <div style="width: 100%;height: 16vw;z-index: 9999">
         <LocationPoint :lon="buildingData.lon" :lat="buildingData.lat" ></LocationPoint>
       </div>
    </el-descriptions-item>
  </el-descriptions>

</div>
</template>

<script>
import LocationPoint from "@/views/BasicInformation/components/LocationPoint";
import SelectPoint from "@/views/BasicInformation/components/SelectPoint";
export default {
  name: "BuildingInfo",
  props: ["buildingInfo"],
  components: {LocationPoint,SelectPoint},
  data() {
    return {
      columnList:[
        {labelName:"项目名称：",columnName:"engineName"},
        {labelName:"工地名称：",columnName:"tenters"},
        {labelName:"建筑工地负责人(电话)：",columnName:"contactsAndPhone"},
        {labelName:"建筑工地环保负责人(电话)：",columnName:"hbContactsAndPhone"},
        {labelName:"施工许可证编号：",columnName:"constructionNum"},
        {labelName:"建设单位名称：",columnName:"buildUnit"},
        {labelName:"建设单位统一社会信用代码：",columnName:"buildUnitNum"},
        {labelName:"施工单位名称：",columnName:"constructionUnit"},
        {labelName:"施工单位统一社会信用代码：",columnName:"constructionUnitNum"},
        {labelName:"所属市：",columnName:"cityName"},
        {labelName:"区县：",columnName:"areaName"},
        {labelName:"占地面积(m²)：",columnName:"buildingMeasure"},
        {labelName:"施工状态：",columnName:"statusName"},
       /* {labelName:"修改日期时间：",columnName:"updatetime"},*/
        {labelName:"所属乡镇：",columnName:"town"},
      ],
      buildingData:this.buildingInfo,
    }
  },
  methods: {
    init(){
    },
  },
  mounted() {
  },
  watch: {}
}
</script>

<style>
.my-label {
  width: 15%;
}

.my-content {
  width: 30%;
}
.demo-block {
  border: 1px solid #ebebeb;
  border-radius: 3px;
  transition: .2s;
  margin-bottom: 24px;
  padding: 0.8vw;
  width: 95%;
}
</style>